<template>
  <div id="app">
    <input ref="paramData" type="hidden" :value="paramData" />
    <div class="mt-2 flex flex-col justify-center items-center">
      <v-btn @click="addItem()" color="primary">{{ $t("shortcodes.comments_widget.add_item") }}</v-btn>
      <div>
        <div>
          <div v-for="(item, index) in Object.values(objectList)" :key="index">
            <div class="mt-2 mb-4">
              <v-btn class="ml-auto d-block mb-2" color="error" text x-small @click="onDelete(item)">
                {{ $t("shortcodes.multiStepQuiz.delete") }}
              </v-btn>
              <div class="flex my-2">
                <v-text-field
                  hide-details
                  v-model="item.author.name"
                  class="mb-4"
                  required
                  :label="$t('shortcodes.comments_widget.author_name')">
                </v-text-field>
              </div>
              <div class="flex my-2">
                <VaMediaObjectFileInput
                  source="favicon"
                  :label="$t('shortcodes.comments_widget.author_picture')"
                  :item-id="item.author.profilePicture.imgId"
                  @update:photo="updatePicture($event, item)" />
              </div>
              <div class="flex my-2">
                <v-text-field
                  hide-details
                  v-model.number="item.likes"
                  class="mb-4"
                  required
                  :label="$t('shortcodes.comments_widget.likes')">
                </v-text-field>
              </div>
              <div class="flex my-2">
                <v-text-field
                  hide-details
                  v-model="item.state"
                  class="mb-4"
                  required
                  :label="$t('shortcodes.comments_widget.location')">
                </v-text-field>
              </div>
              <div class="flex my-2">
                <v-textarea
                  rows="3"
                  hide-details
                  v-model="item.comment"
                  class="mb-4"
                  required
                  :label="$t('shortcodes.comments_widget.comment')">
                </v-textarea>
              </div>
            </div>
            <hr />
          </div>
          <div class="mb-32 mt-8">
            <v-textarea
              hide-details
              :value="JSON.stringify(objectList)"
              class="mb-4"
              required
              :label="$t('shortcodes.comments_widget.comment')">
            </v-textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import definedAbility from "@/ability";

  export default {
    data() {
      return {
        objectList: {},
        paramData: null,
        ability: definedAbility(),
      };
    },
    watch: {
      objectList: {
        handler(newVal) {
          window.parent.postMessage(
            {
              mceAction: "updateComments",
              data: JSON.stringify(newVal),
            },
            origin,
          );
        },
        deep: true,
      },
    },
    beforeMount() {
      this.paramData = this.$route.query.data;
    },
    mounted() {
      if (this.$refs?.paramData?.value !== "null") {
        const paramsString = JSON.parse(this.$refs.paramData.value);
        const passedData = JSON.parse(paramsString);
        if (passedData !== false) {
          this.objectList = passedData;
        }
      } else {
        window.parent.postMessage(
          {
            mceAction: "updateComments",
            data: JSON.stringify(this.objectList),
          },
          origin,
        );
      }
    },
    methods: {
      updatePicture(value, item) {
        if (value === "") {
          for (const i in this.objectList) {
            if (this.objectList[i] === item) {
              this.objectList[i].author.profilePicture = {};
            }
          }
        } else {
          for (const i in this.objectList) {
            if (this.objectList[i] === item) {
              this.objectList[i].author.profilePicture = value["@id"];
              this.objectList[i].author.profilePicture = {
                imgId: value["@id"],
                contentUrl: value.contentUrl,
              };
              if (this.ability.can("upload", "media object to inulti server")) {
                this.objectList[i].author.profilePicture.imgURL = process.env.VUE_APP_API + value.contentUrl;
              } else {
                this.objectList[i].author.profilePicture.imgURL = value.contentUrl;
              }
            }
          }
        }
      },
      addItem() {
        const newId = "_" + Math.random().toString(36).substr(2, 9);
        this.objectList = {
          ...this.objectList,
          [newId]: {
            author: {
              name: "",
              profilePicture: "",
            },
            liked: false,
            likes: 0,
            state: "",
            comment: "",
          },
        };
      },
      onDelete(item) {
        for (const i in this.objectList) {
          if (this.objectList[i] === item) {
            this.$delete(this.objectList, i);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @tailwind base;
  @tailwind utilities;
  @tailwind components;
</style>
